module.exports = __webpack_public_path__ + "img/sad.96f0c53d.svg";